document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelector('.filters');
  const toggle = document.querySelector('.filters-toggle');

  if (!filters || !toggle) return;

  toggle.addEventListener('click', () => {
    filters.classList.toggle('is-open');
  });

});